import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { AuthLayout } from "../components/AuthLayout";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import api, { formatApiErrorDetail } from "../lib/api";

const IMG = "https://images.unsplash.com/photo-1669846125517-6ea5fd9dc9af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjB3b3JraW5nJTIwbGFwdG9wJTIwd2FybSUyMHdpbmRvd3xlbnwwfHx8fDE3ODg0NzIwMjV8MA&ixlib=rb-4.1.0&q=85";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Reset your password" subtitle="Enter your email and we'll send you a reset link." image={IMG}>
      {sent ? (
        <div className="rounded-lg border border-[#E5E2DC] bg-white p-6" data-testid="forgot-confirmation">
          <p className="text-[#1F2924]">If that email is registered, a reset link has been sent. Please check your inbox.</p>
          <Link to="/login" className="mt-4 inline-block text-sm font-medium text-[#2C5545] hover:underline">Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <div className="space-y-2">
            <Label htmlFor="email">Email Address</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
          </div>
          <Button type="submit" disabled={busy} data-testid="forgot-submit"
            className="w-full bg-[#2C5545] hover:bg-[#224336] rounded-lg py-6 text-base font-semibold">
            {busy ? "Sending…" : "Send Reset Link"}
          </Button>
          <Link to="/login" className="block text-center text-sm font-medium text-[#2C5545] hover:underline">Back to sign in</Link>
        </form>
      )}
    </AuthLayout>
  );
}
